import type { ComponentProps } from 'react'

import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  type IconProps,
} from 'components'

export const ExternalLink = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill={fill}
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M25.9065 4.24018C26.487 3.65982 27.2743 3.33337 28.0952 3.33337H43.5715C44.3923 3.33337 45.1796 3.65982 45.7601 4.24018C46.3405 4.82054 46.6667 5.60795 46.6667 6.42861V21.9048C46.6667 22.7255 46.3405 23.5129 45.7601 24.0932C45.1796 24.6736 44.3923 25 43.5715 25C42.7505 25 41.9632 24.6736 41.3827 24.0932C40.8023 23.5129 40.4762 22.7255 40.4762 21.9048V13.9007L20.9978 33.3789C20.7123 33.6744 20.3707 33.9102 19.9931 34.0727C19.6154 34.2344 19.2094 34.3198 18.7984 34.3235C18.3874 34.3273 17.9798 34.2487 17.5994 34.0931C17.219 33.9374 16.8734 33.7077 16.5828 33.4175C16.2922 33.1266 16.0623 32.7812 15.9067 32.4004C15.7511 32.0202 15.6727 31.6129 15.6763 31.2019C15.6799 30.7908 15.7653 30.3842 15.9275 30.0071C16.0897 29.6293 16.3255 29.2877 16.6212 29.0021L36.0995 9.52385H28.0952C27.4819 9.52385 26.8874 9.34173 26.3838 9.00773C26.2133 8.89437 26.0533 8.76364 25.9065 8.61704C25.3261 8.03668 25 7.24927 25 6.42861C25 5.60795 25.3261 4.82054 25.9065 4.24018Z"
        fill={color}
      />
      <path
        d="M5.14652 11.3367C6.30743 10.176 7.88207 9.52385 9.52386 9.52385H18.8096C19.6305 9.52385 20.4178 9.8503 20.9982 10.4307C21.5788 11.011 21.9048 11.7984 21.9048 12.6191C21.9048 13.4397 21.5788 14.2272 20.9982 14.8075C20.4178 15.3879 19.6305 15.7143 18.8096 15.7143H9.52386V40.4762H34.2858V31.1905C34.2858 30.3699 34.6119 29.5824 35.1924 29.0021C35.7729 28.4217 36.5601 28.0953 37.3811 28.0953C38.202 28.0953 38.9892 28.4217 39.5697 29.0021C40.1502 29.5824 40.4763 30.3699 40.4763 31.1905V40.4762C40.4763 42.1183 39.8241 43.6924 38.6632 44.8538C37.5023 46.0146 35.9276 46.6667 34.2858 46.6667H9.52386C7.88207 46.6667 6.30743 46.0146 5.14652 44.8538C3.98562 43.6924 3.33337 42.1183 3.33337 40.4762V15.7143C3.33337 14.0722 3.98562 12.4982 5.14652 11.3367Z"
        fill={color}
      />
    </svg>
  )
}
